export default "__VITE_ASSET__CuKYyler__"